export default "/images/plus.svg?7b4612b4fec6ca9590d5284475d052e6";